/* eslint no-template-curly-in-string: 0 */
import nikeIcon from '../../assets/images/nike-logo.png';
import { PAYMENT_NETWORKS } from "../../utils/enums";

export const nike = {
  id: PAYMENT_NETWORKS.EGIFT_BLACKHAWK_NIKE,
  displayName: "Nike™",
  paywall: {
    tile: {
      displayName: "Nike™",
      tagline: ["Use online or in-store"],
      description: "Use online or in-store",
      logo: nikeIcon
    },
    disabledPaymentNetwork: {
      title: 'Endpoint Not Live',
      description: 'For this trial program, ${paymentNetwork.displayName} is only listed as an example of the 250+ options DigitalPay currently offers.  Click the button below to go back and select a live network. Live networks are not “grayed out.”'
    },
  },
};

export default nike;
